// src/stores/displayStore.js
import { defineStore } from 'pinia'

const LS_KEY = 'pokewudi:display:resolution' // 'low' | 'high'

function safeLoad(defaultValue = 'low') {
  try {
    const v = localStorage.getItem(LS_KEY)
    return v === 'high' || v === 'low' ? v : defaultValue
  } catch {
    return defaultValue
  }
}

function safeSave(value) {
  try {
    localStorage.setItem(LS_KEY, value)
  } catch {}
}

export const useDisplayStore = defineStore('display', {
  state: () => ({
    // low: 普通手机；high: 高端手机
    resolutionMode: safeLoad('low'),
  }),

  getters: {
    isHighResolution: (s) => s.resolutionMode === 'high',
  },

  actions: {
    setResolutionMode(mode) {
      const v = mode === 'high' ? 'high' : 'low'
      if (this.resolutionMode === v) return
      this.resolutionMode = v
      safeSave(v)
    },

    toggleResolution() {
      this.setResolutionMode(this.resolutionMode === 'high' ? 'low' : 'high')
    },

    // 可选：如果你担心某些页面先于 localStorage 可用时初始化（极少见）
    hydrate() {
      this.resolutionMode = safeLoad(this.resolutionMode || 'low')
    },
  },
})
